<template>
  <base-modal
    v-model="showModal"
    :extra-classes="extraClasses"
    @base-modal:closed="closeModal"
  >
    <template #modal-body>
      <keep-alive>
        <component
          :is="currentView"
          :email-only="emailOnly"
          :import-comment="registerImportComment"
        />
      </keep-alive>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../base-modal.vue';
import ModalLoginForm from '../modal-authentication-forms/modal-login-form.vue';
import ModalRegisterForm from '../modal-authentication-forms/modal-register-form.vue';

export default {

  // Component uses other components
  components: {
    ModalLoginForm,
    ModalRegisterForm,
    BaseModal,
  },
  data() {
    return {
      showModal: false,
      currentView: ModalLoginForm,
      emailOnly: false,
      registerImportComment: null,
    };
  },
  computed: {
    extraClasses() {
      return 'Modal--authOnly Modal--noSpacing';
    },
  },

  created() {
    // Authentication Modal is bound to a vue instance in the footer of each page.
    // Vue will not destroy this instance. It will reuse for efficiency. Only the nested components are destroyed.
    this.$bus.$on('bus:global-modal:close', this.closeModal);

    this.$bus.$on('bus:authentication-modal:open-register-modal', ({ importComment }) => {
      this.changeCurrentView('register-template');
      this.registerImportComment = importComment;
      this.openModal();
    });
    this.$bus.$on('bus:authentication-modal:open-login-modal', ({ importComment }) => {
      this.changeCurrentView('login-template');
      this.registerImportComment = importComment;
      this.openModal();
    });

    // Auth Switcher
    this.$bus.$on('bus:authentication:show-login-form', () => { this.changeCurrentView('login-template'); });
    this.$bus.$on('bus:authentication:show-register-form', () => { this.changeCurrentView('register-template'); });
  },

  mounted() {
    document.addEventListener('keyup', (e) => {
      if (this.showModal && e.keyCode === 27) {
        // this.$bus.$emit('rmp:authentication-modal:close');
        this.closeModal();
      }
    });
  },

  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.emailOnly = false;
    },
    changeCurrentView(view) {
      this.currentView = view === 'login-template' ? ModalLoginForm : ModalRegisterForm;
    },
  },
};
</script>
